import { render, staticRenderFns } from "./KeuzedelenInformatie.vue?vue&type=template&id=d373306e&scoped=true"
import script from "./KeuzedelenInformatie.vue?vue&type=script&lang=ts"
export * from "./KeuzedelenInformatie.vue?vue&type=script&lang=ts"
import style0 from "./KeuzedelenInformatie.vue?vue&type=style&index=0&id=d373306e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d373306e",
  null
  
)

export default component.exports